export function isValidJSON (text) {
  try {
    JSON.parse(text)
    return true
  } catch (error) {
    return false
  }
}

export function isEmpty (v) {
  return v === '' || v === undefined || v === null
}
